import { useCallback, useEffect, useState } from "react";
import { DamageService } from "../services/damages";

interface UseDamageMastersReturn {
  damageSeverity: any;
  damageTypes: any;
  damageArea: any;
  loading: boolean;
  error: any;
  refetch: () => void;
}

const useDamageMasters = (inspectionId: string): UseDamageMastersReturn => {
  const [damageSeverity, setDamageSeverity] = useState<any>([]);
  const [damageTypes, setDamageTypes] = useState<any>([]);
  const [damageArea, setDamageArea] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchMasters = useCallback(async () => {
    if (!inspectionId) return;

    try {
      setLoading(true);
      setError(null);

      const [severity, types, area] = await Promise.all([
        DamageService.getDamageMasters(inspectionId, {
          type: "damage-severity",
        }),
        DamageService.getDamageMasters(inspectionId, {
          type: "damage-type",
        }),
        DamageService.getDamageMasters(inspectionId, {
          type: "damage-area",
        }),
      ]);

      setDamageSeverity(severity);
      setDamageTypes(types);
      setDamageArea(area);
    } catch (err) {
      console.error("Error fetching masters:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [inspectionId]);

  useEffect(() => {
    fetchMasters();
  }, [fetchMasters]);

  return {
    damageSeverity,
    damageTypes,
    damageArea,
    loading,
    error,
    refetch: fetchMasters, // optional manual refresh
  };
};

export default useDamageMasters;